import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=73733a80&scoped=true&"
import script from "./not-found.js?vue&type=script&lang=js&"
export * from "./not-found.js?vue&type=script&lang=js&"
import style0 from "./not-found.scss?vue&type=style&index=0&id=73733a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73733a80",
  null
  
)

component.options.__file = "not-found.vue"
export default component.exports